export const RESET_AUTOMATIC_MESSAGES = "RESET_AUTOMATIC_MESSAGES";
export const RESET_AUTOMATIC_MESSAGE = "RESET_AUTOMATIC_MESSAGE";
export const RESET_ERROR = "AUTOMATIC_MESSAGES_RESET_ERROR";

export const GET_AUTOMATIC_MESSAGES = "GET_AUTOMATIC_MESSAGES";
export const SET_AUTOMATIC_MESSAGES = "SET_AUTOMATIC_MESSAGES";

export const API_ERROR = "AUTOMATIC_MESSAGES_API_ERROR";

export const GET_AUTOMATIC_MESSAGE = "GET_AUTOMATIC_MESSAGE";
export const SET_AUTOMATIC_MESSAGE = "SET_AUTOMATIC_MESSAGE";

export const EDIT_AUTOMATIC_MESSAGE = "EDIT_AUTOMATIC_MESSAGE";
export const EDIT_AUTOMATIC_MESSAGE_SUCCESS = "EDIT_AUTOMATIC_MESSAGE_SUCCESS";

export const CREATE_AUTOMATIC_MESSAGE = "CREATE_AUTOMATIC_MESSAGE";
export const CREATE_AUTOMATIC_MESSAGE_SUCCESS = "CREATE_AUTOMATIC_MESSAGE_SUCCESS";

export const DELETE_AUTOMATIC_MESSAGE = "DELETE_AUTOMATIC_MESSAGE";
export const DELETE_AUTOMATIC_MESSAGE_SUCCESS = "DELETE_AUTOMATIC_MESSAGE_SUCCESS";
